import {getState, signalStoreFeature, SignalStoreFeatureResult, withMethods, withState} from '@ngrx/signals';

import {SIGNAL_STORE_METADATA_KEY, SignalStoreMetaData} from './shared/with-metadata-feature.types';

/**
 * Adds meta-data to a signal store.
 *
 * @param metaData - The meta-data to add to the store.
 * @returns A signal store feature that adds the meta-data to the store.
 */
export function withMetaData<Input extends SignalStoreFeatureResult>(metaData: SignalStoreMetaData) {
	return signalStoreFeature(
		withState<
			Input['state'] & {
				[SIGNAL_STORE_METADATA_KEY]: SignalStoreMetaData;
			}
		>({
			[SIGNAL_STORE_METADATA_KEY]: metaData,
		}),
		withMethods(store => ({
			getMetaData: function () {
				return getState(store)[SIGNAL_STORE_METADATA_KEY];
			},
		})),
	);
}
